module.exports = __webpack_public_path__ + "img/1951_no.6cde68f5.svg";